import React, { useState, useEffect } from 'react';
import { subscribeSyncStatus, refreshSyncStatus } from '../services/syncQueue';

const STATE_CONFIG = {
  synced:  { label: 'Synchronisiert', color: '#16a34a', bg: 'rgba(22,163,74,0.08)',  border: 'rgba(22,163,74,0.2)',  icon: <path d="M20 6L9 17l-5-5"/> },
  pending: { label: 'Ausstehend',     color: '#d97706', bg: 'rgba(217,119,6,0.08)', border: 'rgba(217,119,6,0.2)',  icon: <circle cx="12" cy="12" r="10"/> },
  error:   { label: 'Sync-Fehler',    color: '#dc2626', bg: 'rgba(220,38,38,0.08)', border: 'rgba(220,38,38,0.2)',  icon: <><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></> },
  offline: { label: 'Offline · nur Lesen', color: '#66796c', bg: 'rgba(102,121,108,0.08)', border: 'rgba(102,121,108,0.2)', icon: <><line x1="1" y1="1" x2="23" y2="23"/><path d="M16.72 11.06A10.94 10.94 0 0119 12.55M5 12.55a10.94 10.94 0 015.17-2.39M10.71 5.05A16 16 0 0122.56 9M1.42 9a15.91 15.91 0 014.7-2.88M8.53 16.11a6 6 0 016.95 0M12 20h.01"/></> },
};

export default function SyncStatusBar() {
  const [status, setStatus] = useState({ state: 'synced', pending: 0, errors: 0 });
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const unsub = subscribeSyncStatus(s => {
      setStatus(s);
      setVisible(s.state !== 'synced');
    });
    refreshSyncStatus();
    return unsub;
  }, []);

  // Always show on hover, only auto-show for non-synced states
  const show = visible || hovered;
  const cfg = STATE_CONFIG[status.state] || STATE_CONFIG.synced;

  const label = status.state === 'pending' && status.pending > 0
    ? `${status.pending} ausstehend`
    : status.state === 'error' && status.errors > 0
    ? `${status.errors} Fehler`
    : cfg.label;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'fixed', bottom: 72, left: 70, zIndex: 9000,
        display: 'flex', alignItems: 'center', gap: 7,
        padding: '6px 12px', borderRadius: 20,
        background: show ? cfg.bg : 'transparent',
        border: show ? `1px solid ${cfg.border}` : '1px solid transparent',
        cursor: 'default', transition: 'all .2s',
        opacity: show ? 1 : 0.3,
        pointerEvents: 'all',
      }}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={cfg.color} strokeWidth="2">
        {cfg.icon}
      </svg>
      {show && (
        <span style={{ fontSize: 11, fontWeight: 600, color: cfg.color, whiteSpace: 'nowrap' }}>
          {label}
        </span>
      )}
    </div>
  );
}
